import { Injectable } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { OverlayEventDetail } from '@ionic/core';
import { CustomListRangePopoverComponent } from '../../../shared/popovers/custom-list-range-popover/custom-list-range-popover.component';
import { ListOption } from '../../../shared/popovers/types/list-options';
import { User } from '../../users';
import { KudosReason } from './kudos.model';

@Injectable()
export class KudosUIService {
  constructor(private readonly popovers: PopoverController) { }

  async promptKudosReason(installer: User): Promise<OverlayEventDetail<ListOption[]>> {
    const popover = await this.popovers.create({
      component: CustomListRangePopoverComponent,
      cssClass: 'list-range-popover',
      componentProps: {
        title: 'Give Kudos',
        subtitle: `How did ${installer.firstName} go above and beyond? Select all that apply.`,
        multi: true,
        doneText: 'Give Kudos',
        listOptions: [
          {
            name: KudosReason.Dependability,
            label: 'Dependable',
            value: 5,
          },
          {
            name: KudosReason.Professionalism,
            label: 'Professionalism',
            value: 5,
          },
          {
            name: KudosReason.Quality,
            label: 'Exceptional Quality',
            value: 5,
          },
          {
            name: KudosReason.Punctuality,
            label: 'Punctuality',
            value: 5,
          },
          {
            name: KudosReason.Attitude,
            label: 'Attitude',
            value: 5,
          },
          {
            name: KudosReason.TimelyCommunication,
            label: 'Timely Communication',
            value: 5,
          },
          {
            name: KudosReason.LikelyToUseAgain,
            label: 'How Likely To Hire Again',
            value: 5
          }
        ],
      },
    });

    await popover.present();
    return await popover.onDidDismiss();
  }
}
